module.exports = __webpack_public_path__ + "static/media/032-zambia.e1f600a3.svg";